module.exports = __webpack_public_path__ + "img/Floor002658_01.6f8f322b.jpg";